export enum TradingSymbols {
  PLUS = '+',
  MINUS = '-',
  DIVIDE = '/',
  MULTIPLY = '*',
  DOLLAR = '$',
}
